var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { "fill-height": "" } },
    [
      _c(
        "v-layout",
        { attrs: { "align-center": "", "justify-center": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm8: "", md4: "" } },
            [
              _c("v-img", {
                staticClass: "mb-2",
                attrs: {
                  "align-center": "",
                  "justify-center": "",
                  src: _vm.logo,
                  alt: "logo-recuperi"
                }
              }),
              _c(
                "v-card",
                { staticClass: "elevation-12" },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "primary" } },
                    [_c("v-toolbar-title", [_vm._v("Nova senha")])],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          nativeOn: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.validarSubmit.apply(null, arguments)
                            }
                          },
                          model: {
                            value: _vm.valid,
                            callback: function($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid"
                          }
                        },
                        [
                          _c("v-text-field", {
                            ref: "password",
                            attrs: {
                              "prepend-icon": "lock",
                              name: "nova senha",
                              label: "Nova senha",
                              type: _vm.show1 ? "text" : "password",
                              "append-icon": _vm.show1
                                ? "mdi-eye"
                                : "mdi-eye-off",
                              hint:
                                "Sua senha precisa conter no mín. 12 caracteres: maiúsculas, números e caracteres especiais (exemplo: @,!,#)",
                              "data-cy": "signinPasswordField",
                              rules: _vm.passwordRules,
                              required: ""
                            },
                            on: {
                              "click:append": function($event) {
                                _vm.show1 = !_vm.show1
                              },
                              input: function($event) {
                                return _vm.$refs.passwordConfirmation.validate()
                              }
                            },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "tab",
                                    9,
                                    $event.key,
                                    "Tab"
                                  )
                                )
                                  return null
                                return _vm.$refs.passwordConfirmation.focus()
                              }
                            },
                            model: {
                              value: _vm.password,
                              callback: function($$v) {
                                _vm.password = $$v
                              },
                              expression: "password"
                            }
                          }),
                          _c("v-text-field", {
                            ref: "passwordConfirmation",
                            attrs: {
                              "prepend-icon": "lock",
                              name: "Repita a nova senha",
                              label: "Repita a nova senha",
                              type: _vm.show1 ? "text" : "password",
                              "append-icon": _vm.show1
                                ? "mdi-eye"
                                : "mdi-eye-off",
                              "data-cy": "signinPasswordField",
                              rules: _vm.passwordRulesConfirmation,
                              required: ""
                            },
                            on: {
                              "click:append": function($event) {
                                _vm.show1 = !_vm.show1
                              }
                            },
                            model: {
                              value: _vm.passwordConfirmation,
                              callback: function($$v) {
                                _vm.passwordConfirmation = $$v
                              },
                              expression: "passwordConfirmation"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            disabled: !_vm.valid,
                            "data-cy": "signinSubmitBtn",
                            loading: _vm.load_troca_senha
                          },
                          on: { click: _vm.submit }
                        },
                        [
                          _vm._v(" Registrar nova senha "),
                          _c("v-icon", { staticClass: "ml-1" }, [
                            _vm._v("chevron_right")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.snackbar
        ? _c("Snackbar", {
            attrs: {
              mostrarSnackbar: _vm.snackbar,
              corSnackbar: "red white--text",
              mensagemSnackbar: _vm.snackbarText
            },
            on: {
              fecharSnackbar: function($event) {
                _vm.snackbar = false
              }
            }
          })
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "400" },
          model: {
            value: _vm.dialogMensagemFinal,
            callback: function($$v) {
              _vm.dialogMensagemFinal = $$v
            },
            expression: "dialogMensagemFinal"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-text", { staticClass: "pt-5 mb-n10" }, [
                _vm._v(_vm._s(_vm.resposta_requisicao))
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", text: "", to: "/login" },
                      on: {
                        click: function($event) {
                          _vm.dialogMensagemFinal = !_vm.dialogMensagemFinal
                        }
                      }
                    },
                    [_vm._v("ok")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }